import React from "react";
import { PrecoDisplay } from "./PrecoDisplay";

interface PrecoFaixaProps {
  produto: { price?: number; priceMin?: number; priceMax?: number };
  classeSimbolo?: string;
  classeInteiro?: string;
  classeDecimal?: string;
  classe?: string;
}

/**
 * Preço de card: "R$ 100,00 - R$ 150,00" para um produto vendido por
 * combinação com preços diferentes, um valor só quando menor e maior são
 * iguais ou o produto não tem variações.
 */
export const PrecoFaixa: React.FC<PrecoFaixaProps> = ({
  produto,
  classe,
  ...classes
}) => {
  const minimo = produto.priceMin ?? produto.price ?? 0;
  const maximo = produto.priceMax ?? minimo;

  if (maximo <= minimo) {
    return <PrecoDisplay valor={minimo} classe={classe} {...classes} />;
  }

  return (
    <span className={classe}>
      <PrecoDisplay valor={minimo} {...classes} />
      {" - "}
      <PrecoDisplay valor={maximo} {...classes} />
    </span>
  );
};
